import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay } from 'swiper/modules';
import { IconChevronRight, IconChevronLeft } from '@tabler/icons-react';
import threeemlogo from '../images/3m-logo.png';
import nexperialogo from '../images/nexperia-icon.png';
import safranlogo from '../images/safran-landing-system.png';
import presslogo from '../images/press-metal-aluminium-logo.png';
import lyondellBaselllogo from '../images/lyondellBasell-polymers-logo.png';
import cpaklogo from '../images/c-pak-logo.png';
import sliderbg1 from '../images/roadmapp-slider-image1.PNG';
import sliderbg2 from '../images/roadmapp-slider-image2.PNG';
import sliderbg3 from '../images/slider-img-sliderbg3.JPG';
import sliderbg4 from '../images/slider-img-sliderbg4.PNG';
import sliderbg5 from '../images/slider-img-sliderbg5.PNG';
import sliderbg6 from '../images/slider-img-sliderbg6.JPG';

import sliderbg7 from '../images/slider-img-sliderbg7.JPG';
import sliderbg8 from '../images/slider-img-sliderbg8.PNG';
import sliderbg9 from '../images/slider-img-sliderbg9.PNG';
import sliderbg10 from '../images/slider-img-sliderbg10.JPG';


const App = () => {
    const slides = [
        {
            Year: "1992",
            title: 'GXL Engineering is established',
            Dec: "Founded with a commitment to deliver high-precision mechanical components and systems to industrial clients demanding exacting standards.",
            sliderimg: sliderbg1,
            slidericon: threeemlogo
        },
        {
            Year: "1998",
            title: 'First CNC Machining Facility Opened',
            Dec: "Launched in-house CNC machining capabilities to ensure tighter tolerances and improved quality control across all custom builds.",
            sliderimg: sliderbg2,
            slidericon: nexperialogo
        },
        {
            Year: "2007",
            title: 'ISO 9001 Certification Achieved',
            Dec: "Quality and precision formalized with international standards, reinforcing GXL’s dedication to engineering excellence.",
            sliderimg: sliderbg3,
            slidericon: safranlogo
        },
        {
            Year: "2015",
            title: 'Advanced Metrology Division Introduced',
            Dec: "Invested in state-of-the-art metrology and inspection systems, enabling micron-level validation and reverse engineering.",
            sliderimg: sliderbg4,
            slidericon: cpaklogo
        },
        {
            Year: "2020",
            title: 'Precision Assembly & Cleanroom Operations Launched',
            Dec: "Expanded capabilities to include precision sub-assemblies and cleanroom-level production for high-sensitivity industries like aerospace and medical devices.",
            sliderimg: sliderbg5,
            slidericon: presslogo
        },
        {
            Year: "2025",
            title: 'Driving the Future of Precision Engineering',
            Dec: "GXL evolves into a full-spectrum precision partner—combining ultra-precise fabrication, smart design systems, and engineering consultation to lead innovation in the field.",
            sliderimg: sliderbg6,
            slidericon: lyondellBaselllogo
        },
          {
            Year: "2025",
            title: 'Driving the Future of Precision Engineering',
            Dec: "GXL evolves into a full-spectrum precision partner—combining ultra-precise fabrication, smart design systems, and engineering consultation to lead innovation in the field.",
            sliderimg: sliderbg7,
            slidericon: lyondellBaselllogo
        },
          {
            Year: "2025",
            title: 'Driving the Future of Precision Engineering',
            Dec: "GXL evolves into a full-spectrum precision partner—combining ultra-precise fabrication, smart design systems, and engineering consultation to lead innovation in the field.",
            sliderimg: sliderbg8,
            slidericon: lyondellBaselllogo
        },
         {
            Year: "2025",
            title: 'Driving the Future of Precision Engineering',
            Dec: "GXL evolves into a full-spectrum precision partner—combining ultra-precise fabrication, smart design systems, and engineering consultation to lead innovation in the field.",
            sliderimg: sliderbg9,
            slidericon: lyondellBaselllogo
        },
          {
            Year: "2025",
            title: 'Driving the Future of Precision Engineering',
            Dec: "GXL evolves into a full-spectrum precision partner—combining ultra-precise fabrication, smart design systems, and engineering consultation to lead innovation in the field.",
            sliderimg: sliderbg10,
            slidericon: lyondellBaselllogo
        },
    ];

    const swiperRef = useRef(null);

    return (
        <section className='lg:py-16 py-10 bg-[#E4E5E7] '>
            <div className='container lg:px-10 px-6 max-w-[1600px] mx-auto'>
                <div className='flex justify-between items-center'>
                    <div className='space-y-2'>
                        <h2 className='text-gray-800 lg:text-5xl text-start text-3xl  font-medium'>Our Journey</h2>
                        <p className='text-gray-800 text-start lg:text-lg text-base font-medium'>
                            Crafting the future of precision engineering, one innovation at a time.
                        </p>
                    </div>
                    <div className='sm:flex items-center gap-4 hidden'>
                        <button
                            aria-label="Previous slide"
                            className='bg-[#121317] text-white p-2.5 rounded-full'
                            onClick={() => swiperRef.current?.slidePrev()}
                        >
                            <IconChevronLeft stroke={2} />
                        </button>
                        <button
                            aria-label="Next slide"
                            className='bg-[#121317] text-white p-2.5 rounded-full'
                            onClick={() => swiperRef.current?.slideNext()}
                        >
                            <IconChevronRight stroke={2} />
                        </button>
                    </div>
                </div>

                <div className="space-y-6 lg:mt-10 mt-6">
                    <Swiper
                        spaceBetween={20}
                        slidesPerView={3}
                        loop={true}
                        autoplay={{ delay: 5000, disableOnInteraction: false }}
                        modules={[Autoplay]}
                        onSwiper={(swiper) => {
                            swiperRef.current = swiper;
                        }}
                        breakpoints={{
                            1024: {
                                slidesPerView: 3,
                            },
                            650: {
                                slidesPerView: 2,
                            },
                            0: {
                                slidesPerView: 1,
                            },
                        }}
                    >
                        {slides.map((slide, index) => (
                            <SwiperSlide key={index}>
                                <div
                                    style={{ backgroundImage: `url(${slide.sliderimg})` }}
                                    className="object-cover relative max-h-[340px] min-h-[340px] bg-no-repeat bg-cover py-6 bg-left rounded-lg overflow-hidden"
                                >
                                    <div className="absolute inset-0 bg-black opacity-70 z-0"></div>
                                    <div className="relative z-10 sm:p-8 p-4 flex flex-col justify-between min-h-[320px]">
                                        <div>
                                            {/* <img src={slide.slidericon} alt={slide.title} loading="lazy" className="w-34 object-cover" /> */}
                                        </div>
                                        <div>
                                            <div className="space-y-1 md:pb-1 pb-2">
                                                {/* <p className='text-[#fff]/80 text-base font-medium text-start'>{slide.Year}</p>
                                                <div>
                                                    <h3 className="text-white md:text-xl text-lg font-semibold ">{slide.title}</h3>
                                                    <p className='text-white text-base font-normal text-start'>{slide.Dec}</p>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <div className='flex justify-center'>
                        <div className='flex items-center gap-4 sm:hidden'>
                            <button
                                aria-label="Previous slide"
                                className='bg-[#121317] text-white p-2.5 rounded-full'
                                onClick={() => swiperRef.current?.slidePrev()}
                            >
                                <IconChevronLeft stroke={2} />
                            </button>
                            <button
                                aria-label="Next slide"
                                className='bg-[#121317] text-white p-2.5 rounded-full'
                                onClick={() => swiperRef.current?.slideNext()}
                            >
                                <IconChevronRight stroke={2} />
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default App;
